import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AppConfigService {
  public appConfig;
  private httpClient: HttpClient;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  loadAppConfig() {
    return this.httpClient.get('/assets/config.json')
      .toPromise()
      .then(data => {
        this.appConfig = data;
      });
  }

  get<T extends any>(configPath: (n: any) => T, defaultValue?: T): T {
    var configurationValue: any = defaultValue;
    try {
      configurationValue = configPath(this.appConfig);
      if (!configurationValue)
        throw new Error("The configuration does not contain " + configPath.toString());
    } catch (e) {
      if (!defaultValue) {
        throw new Error("The configuration does not contain " + configPath.toString());
      }
      else
        configurationValue = defaultValue;
    }

    return configurationValue;
  }

  static initializer(appConfig: AppConfigService) {
    return () => {
      return appConfig.loadAppConfig();
    };
  };

}